import {RouteTabParameter} from '../../types/common/RouteTabParameter';

export interface SessionPaths {
    SessionProfile: string,
    SessionSearch: string,
    SessionReview: string,
}

export const sessionPaths: SessionPaths = {
    SessionProfile: '/sessions/view/:idParam',
    SessionSearch: '/sessions/search',
    SessionReview: '/sessions/replay/:idParam',
};

export interface ISessionProfileTabs {
    activity: RouteTabParameter;
    details: RouteTabParameter;
}

export const sessionProfileTabs: ISessionProfileTabs = {
    activity: new RouteTabParameter(0, 'Activity', 'activity'),
    details: new RouteTabParameter(1, 'Files', 'files'),
}

export const profileTabs = [
    sessionProfileTabs.activity,
];

export const getSessionProfileTab = (query: string | undefined | null) => profileTabs.find(x => x.query === query);
